module.exports = __webpack_public_path__ + "img/banner_title_mobile_sc.265ffc04.gif";